"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Spinner_module_css_1 = __importDefault(require("./Spinner.module.css"));
const Spinner = ({ size = 'xs', variant = 'primary', inverted = false, className, ...props }) => {
    return (react_1.default.createElement("svg", Object.assign({}, props, { className: classnames_1.default(className, Spinner_module_css_1.default.spinner, Spinner_module_css_1.default[`variant-${variant}`], Spinner_module_css_1.default[`size-${size}`], {
            [Spinner_module_css_1.default.inverted]: inverted
        }), viewBox: "0 0 50 50", role: "progressbar" }),
        react_1.default.createElement("circle", { className: Spinner_module_css_1.default.path, cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "6" })));
};
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map